import { required, optional, obj } from "AppReact/schema";

const ratings = {
  veryGood: required("string"),
  good: required("string"),
  bad: required("string"),
};

export const videoTraining = {
  id: optional("integer"),
  category_id: required("integer"),
  category_name: required("string"),
  trainer_id: required("integer"),
  trainer_name: required("string"),
  description: required("string"),
  alt_text: required("string"),
  is_highlighted: required("boolean"),
  transcript: required("string"),
  num_views: required("integer"),
  publish_date: optional("jsDate"),
  status: required("string"),
  thumbnail_url: required("string"),
  title: required("string"),
  video_url: required("string"),
  video_uuid: required("string"),
  ratings: obj(ratings),
};

export const videoTrainingDefaultValue = {
  id: null,
  category_id: "",
  category_name: "",
  trainer_id: "",
  trainer_name: "",
  description: "",
  alt_text: "",
  is_highlighted: false,
  transcript: "",
  num_views: "",
  publish_date: "",
  status: "",
  thumbnail_url: "",
  title: "",
  video_url: "",
  video_uuid: "",
  tags: [],
  ratings: { veryGood: "0", good: "0", bad: "0" },
};
